import {BaseAppModel} from "./AppModel";

export enum Times {
    ONCE = 'ONCE',
    REPEATEDLY = 'REPEATEDLY'
}

export const timesZh = {
    ONCE: '一次',
    REPEATEDLY: '多次'
}

export default class TaskGenerator<T extends TaskGenerator<T>> extends BaseAppModel<T> {
    name!: string
    cronExp!: string
    times!: Times

    enabled!: boolean
    ext?: Map<string, unknown> = undefined

    taskName!: string
    taskDesc!: string
    taskContent?: string = undefined

    leftTimeToNext?: string = undefined
}
